<bootstrap-popup
	[id]="id"
	[title]="'Formulaire de fin d\'acc&egrave;s'"
	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	>
	<ng-container *ngIf="loaded">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h3>
					Fin de l'acc&egrave;s <b>{{ acces.numero }}</b> 
					<ng-container *ngIf="ouvrages.length">
						{{ ouvrages.length == 1 ? ' sur l\'ouvrage ' : ' sur les ouvrages ' }} <b>{{ ouvrages[0].nom }}</b>
						<ng-container *ngIf="ouvrages.length >= 2">
							&nbsp;, <b>{{ ouvrages[1].nom }}</b>
						</ng-container>
						<ng-container *ngIf="ouvrages.length >= 3">
							&nbsp;, ...
						</ng-container>
					</ng-container>
					démarré le {{ acces.dateDebut | localDateTimeToDate: acces.ice | date : "dd/MM/yyyy 'à' HH:mm"}}{{ acces.dateFermeture ? ', terminé le ' : ''}} {{ acces.dateFermeture | localDateTimeToDate: acces.ice | date : "dd/MM/yyyy 'à' HH:mm"}}
				</h3>
			</div>
			<div class="panel-body">
				<form class="form-horizontal">
					<div class="form-group">
						<label for="choixDateFin" class="col-sm-4 control-label">Date de fin&nbsp;:</label>
						<div class="col-sm-5 col-md-4">
		                    <date-input
		                    	[id]="'dateFinInput'"
		                    	[localDateMax]="dateFinMax"
		                    	[localDateMin]="dateMin"
		                    	[(localDate)]="dateFin" 
		                    	(localDateChange)="dateFinHasChanged($event)"
		                    	>
		                    </date-input>
						</div>
					</div>
					<div class="form-group">
						<label for="heureFin" class="col-sm-4 control-label">Heure de fin&nbsp;:</label>
						<div class="col-sm-7">
		                    <time-input
		                    	[id]="'heureFinInput'"
		                    	[stepMinute]="1"
		                    	[max]="heureFinMax"
		                    	[(localTime)]="heureFin">
		                    </time-input>
						</div>
					</div>

					<div class="form-group">
						<label class="control-label col-sm-4">Etat des Ouvrages&nbsp;:</label>
						<div class="col-sm-8 etatOuvrage">
							<div *ngFor="let ouvrage of ouvrages; let index = index;">
								<label class="radio-inline">{{ ouvrage.nom }}</label>
								<ng-container *ngIf="ouvrage.classeOuvrage === classeOuvrageWT.id">
									<label class="radio-inline" *ngFor="let option of etatsOuvrageOptionsWT; let indexOption = index">
										<input type="radio"
											[name]="'etatOuvrage_' + ouvrage.id"
											[id]="'etatOuvrage_' + ouvrage.id + '_' + indexOption"
											[value]="option.value"
											required
											[(ngModel)]="etatOuvrages[index]"
										/>
										<span [style.color]="etatOuvrageColors[option.value]" [attr.title]="option.title">{{ option.label }}</span>
									</label>
								</ng-container>
								<ng-container *ngIf="ouvrage.classeOuvrage !== classeOuvrageWT.id">
									<label class="radio-inline" *ngFor="let option of etatsOuvrageOptionsNonWT; let indexOption = index">
										<input type="radio"
											[name]="'etatOuvrage_' + ouvrage.id"
											[id]="'etatOuvrage_' + ouvrage.id + '_' + indexOption"
											[value]="option.value"
											required
											[(ngModel)]="etatOuvrages[index]"
										/>
										{{ option.label }}
									</label>
								</ng-container>
							</div>
						</div>
					</div>

					<div class="form-group" *ngIf="shouldDisplayPorteFermee" >
						<label class="control-label col-sm-4">Porte ferm&eacute;e ?</label>
						<div class="col-sm-8">
							<label class="radio-inline" *ngFor="let option of ouiNonOptions; let index = index">
								<input type="radio"
									name="porteFermee"
									[id]="'porteFermee_' + index"
									[value]="option.value"
									required
									[(ngModel)]="porteFermee"
								/>
								{{ option.label }}
							</label>
						</div>
					</div>
				
					<div class="form-group" *ngIf="allowsOuvragesConcernes" >
	                    <ouvrage-by-sous-parc-multi-selector
						    [id]="'choixOuvrages'"
						    [label]="'Ouvrage(s) concern&eacute;(s)'"
							[labelClass]="'control-label col-sm-4'"
							[fieldClass]="'col-sm-8'"
							[ouvrageFilter]="filterOuvragesConcernes"
							[ouvrageLabelGetter]="getOuvrageConcerneLabel"
						    [parc]="parc"
						    [(selectedOuvrageIds)]="selectedOuvragesConcernesIds"
						    >
					    </ouvrage-by-sous-parc-multi-selector>
					</div>
					
					<div class="form-group meteo-group">
						<label class="col-sm-4 control-label">M&eacute;t&eacute;o :</label>
						<div class="col-sm-8 indicateurs-list">
							<span class="popover__wrapper" *ngFor="let indicateur of indicateurs">
								<i class="fa-2x {{ indicateur.icon }}" [style.color]="indicateur.couleur" ></i>
								<div class="popover__content">
									<div class="panel panel-default modal-sm">
										<div class="panel-heading" role="document">
											<h3>{{ indicateur.nom }}</h3>
										</div>
										<div class="panel-body">
											<strong>Niveau&nbsp;:</strong><br/>
											<span>{{ indicateur.niveau }}</span><br/>
											<br/>
											<ng-container *ngIf="indicateur.regle">
												<strong>R&egrave;gle applicable&nbsp;:</strong><br/>
												<span class="regle">{{ indicateur.regle }}</span>
											</ng-container>
											<strong *ngIf="!indicateur.regle">Aucune r&egrave;gle connue.</strong><br/>
											<br/>
											<ng-container *ngIf="indicateur.dateModification">
											<strong>Date de dernière modification&nbsp;:</strong><br/>
											<span class="regle">{{ indicateur.dateModification | localDateTimeToDate: true | date : 'dd/MM/yyyy à HH:mm' }}</span>
											</ng-container>
										</div>
									</div>
								</div>
							</span>
						</div>
					</div>
					
					<div class="form-group">
						<label class="control-label col-sm-4">Arr&ecirc;t machine ?</label>
						<div class="col-sm-8">
							<label class="radio-inline" *ngFor="let option of ouiNonOptions; let index = index">
								<input type="radio"
									name="arretMachine"
									[id]="'arretMachine_' + index"
									[value]="option.value"
									required
									[(ngModel)]="arretMachine"
								/>
								{{ option.label }}
							</label>
						</div>
					</div>

					<acces-association-arrets
						*ngIf="parc?.energie === 'Eolienne' && arretMachine"
						[accesId]="acces.id"
						(commentaireArretsChange)="commentaireArrets = $event"
						(arretsAccesChange)="arretsAcces = $event"
						(onSignalementNoArrets)="signalerNoArretsFound($event)"
						[initialArretsAcces]="arretsAcces"
						>
					</acces-association-arrets>
				
					<div class="form-group" *ngIf="operations && operations.length">
						<label for="comment" class="col-sm-4 control-label">Fermer les op&eacute;rations associ&eacute;es&nbsp;?</label>
						<div class="col-sm-8 col-md-7">
							<label *ngFor="let operation of operations; let index = index" class="checkbox labelNormal labelAligned labelCliquable" >
								<input type="checkbox" [name]="'fermetureOperation_' + index" [(ngModel)]="fermeturesOperations[index]" />
								<span>{{ operation.ouvrage.nom + ':' + (operation.acte ? operation.acte : operation.entity.numero) }}</span>
							</label>
						</div>
					</div>
					<div class="form-group">
						<label for="comment" class="col-sm-4 control-label">Commentaire&nbsp;:</label>
						<div class="col-sm-8 col-md-7">
							<textarea class="form-control" maxlength="1024" type="text" id="commentFermeture" name="commentFermeture" [(ngModel)]="commentaireFermeture"></textarea>
						</div>
					</div>

					<div class="form-group" *ngIf="memosOnParc.length">
						<label for="comment" class="col-sm-4 control-label label-memo">M&eacute;mos associ&eacute;s au parc :</label>
						<div class="col-sm-8 col-md-7 memo-associes">
							<ul class="memo-list">
								<li [ngClass]="memo.entity.niveauId == 1 ? 'popover__wrapper text-primary' : 'popover__wrapper text-danger'" *ngFor="let memo of memosOnParc">
			          				<span>{{ memo.categorie }} {{ memo.entity.intitule }}</span>
			          				<span *ngIf="memo.entity.dateDebut && !memo.entity.dateFin">
			            				(le {{ memo.entity.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memo.entity.dateDebut && memo.entity.dateFin">
			            				(du {{ memo.entity.dateDebut | displayLocalDate }} au {{ memo.entity.dateFin | displayLocalDate }})
			          				</span>
				        			<div class="popover__content">
				          				<div class="panel panel-default">
				            				<div class="panel-heading" role="document">
				              					<h3>Commentaire</h3>
				            				</div>
				            				<div class="panel-body">
				              					<p>{{ memo.entity.commentaire }}</p>
				            				</div>
				          				</div>
				        			</div>
								</li>
							</ul>
						</div>
					</div>

					<div class="form-group" *ngIf="memosOnOuvrages.length">
						<label for="comment" class="col-sm-4 control-label label-memo">M&eacute;mos associ&eacute;s aux ouvrages :</label>
						<div class="col-sm-8 col-md-7 memo-associes">
							<ul *ngIf="memosOnOuvrages.length > 1">
								<li [class]="memo.entity.niveauId == 1 ? 'popover__wrapper text-primary' : 'popover__wrapper text-danger'" *ngFor="let memo of memosOnOuvrages">
									<span>{{ memo.categorie }}{{ memo.entity.intitule }}</span>
									<span *ngIf="memo.entity.dateDebut && !memo.entity.dateFin">
			            				(le {{ memo.entity.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memo.entity.dateDebut && memo.entity.dateFin">
			            				(du {{ memo.entity.dateDebut | displayLocalDate }} au {{ memo.entity.dateFin | displayLocalDate }})
			          				</span>
									<div class="popover__content">
										<div class="panel panel-default">
											<div class="panel-heading" role="document">
												<h3>Commentaire</h3>
											</div>
											<div class="panel-body">
												<p>{{ memo.entity.commentaire }}</p>
											</div>
										</div>
									</div>
								</li>
							</ul>
							<span class="popover__wrapper" *ngIf="memosOnOuvrages.length === 1" [class]="memosOnOuvrages[0].entity.niveauId == 1 ? 'text-primary' : 'text-danger'">
								{{ memosOnOuvrages[0].categorie }}{{ memosOnOuvrages[0].entity.intitule }}
									<span *ngIf="memosOnOuvrages[0].entity.dateDebut && !memosOnOuvrages[0].entity.dateFin">
			            				(le {{ memosOnOuvrages[0].entity.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memosOnOuvrages[0].entity.dateDebut && memosOnOuvrages[0].entity.dateFin">
			            				(du {{ memosOnOuvrages[0].entity.dateDebut | displayLocalDate }} au {{ memosOnOuvrages[0].entity.dateFin | displayLocalDate }})
			          				</span>
									<div class="popover__content">
								    <div class="panel panel-default">
								      <div class="panel-heading" role="document">
								        <h3>Commentaire</h3>
								      </div>
								      <div class="panel-body">
								        <p>{{ memosOnOuvrages[0].entity.commentaire }}</p>
								      </div>
								    </div>
								  </div>
							</span>
						</div>
					
					</div>
				</form>			
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!loaded">
		Chargement...
	</ng-container>
	<div class="modal-footer">
		<div class="form-group text-center">
			<br/>
			<button type="button" class="btn default" (click)="close()">Annuler</button>
			<ng-container *ngIf="acces">
				<button [disabled]="shouldDisableButtons" *ngIf="acces.etat !== 2 && user.id === acces.cacId" type="button" class="btn btn-success" (click)="save('')">Enregistrer</button>
				<button [disabled]="shouldDisableButtons" *ngIf="acces.etat === 2 && user.id === acces.cacId" type="button" class="btn btn-warning" (click)="save('create_memo')">Fermer et créer un memo</button>
				<button [disabled]="shouldDisableButtons" *ngIf="acces.etat === 2 && (user.id === acces.cacId || (user.id === acces.ccId && acces.typeAcces === 1))" type="button" class="btn btn-success" (click)="save('')">Fermer l'acc&egrave;s</button>
				<button [disabled]="shouldDisableButtons" *ngIf="acces.etat === 2 && user.id === acces.cacId" type="button" class="btn btn-primary" (click)="save('duplicate')">Fermer et dupliquer</button>
				<button [disabled]="shouldDisableButtons || demandeFermeture" *ngIf="acces.etat === 2 && (user.id !== acces.cacId && (user.id !== acces.ccId || acces.typeAcces !== 1))" type="button" class="btn btn-warning" (click)="demanderFermeture()"
				 [matTooltip]="demandeFermeture ? 'Il y a déjà une demande de fermeture sur cet accès' : ''">Demander la fermeture</button>
				<button [disabled]="shouldDisableButtons" *ngIf="acces.etat === 2 && (user.id === acces.cacId && demandeFermeture)" type="button" class="btn btn-danger" (click)="annulerFermeture()">Annuler la fermeture</button>
			</ng-container>
		</div>
	</div>	   	
</bootstrap-popup>
<edit-memo-dialog></edit-memo-dialog>
